jQuery( document ).ready( function( $ ) {
  // Your JavaScript goes here
    var $header = $('.js-header');
    $('.js-header-toggle').click(function(){
        $header.toggleClass('open');
    });
});
